import { inventoryApi } from '../api/inventoryApi'
import type { InventoryCategoryData } from '../schema/inventorySchema'

export const updateCategory = async (category: InventoryCategoryData) => {
  try {
    const { data } = await inventoryApi.updateCategory(category)
    return data
  } catch (error) {
    console.error(`Error updating category: `, error)
    throw error
  }
}
